// Local persistence for the workspace-scoped `enableDarkThemeSwitcher` flag.
//
// The teamform-api backend silently drops `enableDarkThemeSwitcher` from
// `workspace.config.featureFlags` on write today (the mutation echoes the
// value back but `getWorkspace` does not return it). Until the API supports
// the key, we cache the toggle state in localStorage keyed by workspace id
// so the user-menu dark theme switcher persists across reloads.
//
// TODO: remove once teamform-api persists `enableDarkThemeSwitcher` on
// `workspace.config.featureFlags`.

const STORAGE_KEY_PREFIX = "teamform.enableDarkThemeSwitcher";

const buildKey = (workspaceId) =>
  workspaceId ? `${STORAGE_KEY_PREFIX}.${workspaceId}` : STORAGE_KEY_PREFIX;

export const readDarkThemeSwitcherOverride = (workspaceId) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(buildKey(workspaceId));
    if (raw === "true") {
      return true;
    }
    if (raw === "false") {
      return false;
    }
    return null;
  } catch {
    return null;
  }
};

export const writeDarkThemeSwitcherOverride = (workspaceId, value) => {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  try {
    window.localStorage.setItem(buildKey(workspaceId), String(Boolean(value)));
  } catch {
    // ignore quota / privacy-mode failures
  }
};
